module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-flag-w-7c850156d5391682ffb5e197eaf3e6dc.svg";